import * as React from "react";
import { forwardRef } from "react";
const SvgLegendRelationIndirect = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "none",
	height: "1em",
	viewBox: "0 0 29 12",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M8.00002 7H5.00002L5 5.00001H8L8.00002 7Z",
	fill: "#878E98"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M3.00002 7H1.71661e-05L0 5.00001H3L3.00002 7Z",
	fill: "#878E98"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M13 7H10L10 5.00001H13L13 7Z",
	fill: "#878E98"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M18 7H15L15 5.00001H18L18 7Z",
	fill: "#878E98"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M24 12L22.5 10.5L26.5 6L22.5 1.5L24 0L29 5.99995L24 12Z",
	fill: "#878E98"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M23 7H20L20 5.00001H23L23 7Z",
	fill: "#878E98"
}));
const ForwardRef = forwardRef(SvgLegendRelationIndirect);
export default ForwardRef;
